import styled from "styled-components";

export const WidthWrapper = styled.div`
  width: 85%;
  max-width: 1500px;
  margin: auto;
`;
